import { AlgoData } from "../../types";
import { Behavior } from "../../../configTab/algoSpec";

export const getAlgoBehavoir = (
  algo_data: AlgoData | undefined
): Behavior | undefined => {
  if (algo_data?.behavior !== undefined) {
    return algo_data.behavior as Behavior;
  }
  
  return undefined;
};

